<template>
  <div>
    <div
      v-if="loading"
      class="text-center p-5"
    >
      Loading form...
    </div>
    <div
      v-else-if="loadError"
      class="text-center p-5 text-danger"
    >
      {{ loadError }}
    </div>
    <template v-else>
      <div>
        <div class="formWrapper niche-wr filled">
          <b-row>
            <b-col cols="12">
              <div class="form-header floatCss">
                <b-row>
                  <b-col cols="12">
                    <div class="form-header-inner d-flex justify-content-between">
                      <div class="d-flex">
                        <div class="dForm-top-logo">
                          <img :src="logoSrc">
                        </div>
                        <div class="dForm-companyDetails">
                          <div class="dForm-cmBlock">
                            <h2>
                              <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                            </h2>
                          </div>
                          <div class="dForm-cmBlock2">
                            <p>(Co. Reg. No. 200401183W)</p>
                            <p>(GST Group Reg. No. M90364395L)</p>
                          </div>
                        </div>
                      </div>
                      <div class="dForm-top-right d-flex">
                        <h5 class="text-block font-small-12">
                          REV: 6
                        </h5>
                        <h5>File No: {{ formData.fileNo || '-' }}</h5>
                        <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle">
                      <h2>sales order - urn 骨灰瓮认购同意书</h2>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row class="payment-plan-section">
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <div class="pp-section-tittle">
                    <p>I hereby agree to purchase the cinerary urn (s) specified hereunder for the consideration stipulated herein upon the terms and subject to the conditions stipulated herein.</p>
                    <h4>本人同意购买下列骨灰瓮,售价注明如下,並遵守以下所附的条件</h4>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="ssfp-form-wrapper">
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <div class="pp-section-tittle2">
                    <h2>PARTICULARS of purchaser 购买者资料</h2>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col cols="12">
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      Full Name as in NRIC / Passport <br>身份证 / 护照上的全名
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.customerName || '-' }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col
                  cols="7"
                  md="7"
                  lg="7"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      NRIC/ Passport No <br>身份证/ 护照号码
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.customerNric || '-' }}
                    </div>
                  </div>
                </b-col>
                <b-col
                  cols="5"
                  md="5"
                  lg="5"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-2">
                      Nationality <br>国籍
                    </div>
                    <div class="ssfp-text-field-input-2">
                      {{ formData.customerNationality || '-' }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col
                  cols="7"
                  md="7"
                  lg="7"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      Birth Date <br>出生日期
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.customerDob || '-' }}
                    </div>
                  </div>
                </b-col>
                <b-col
                  cols="5"
                  md="5"
                  lg="5"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-2">
                      Sex <br>性別
                    </div>
                    <div class="ssfp-text-field-input-3">
                      <div
                        class="ssfp-check-box"
                        :class="{ active: formData.customerSex === 'Male' }"
                      >
                        Male 男
                      </div>
                      <div
                        class="ssfp-check-box"
                        :class="{ active: formData.customerSex === 'Female' }"
                      >
                        Female 女
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col cols="12">
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      Permanent Address <br>永久地址
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.permanentAddress }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col cols="12">
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      Correspondence Address <br>通讯地址
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.correspondenceAddress }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col
                  cols="7"
                  md="7"
                  lg="7"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      E-mail Address <br>电邮
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.customerEmail || '-' }}
                    </div>
                  </div>
                </b-col>
                <b-col
                  cols="5"
                  md="5"
                  lg="5"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-2">
                      Contact No. <br>联络号码
                    </div>
                    <div class="ssfp-text-field-input-2">
                      {{ formData.customerContact || '-' }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-section-tittle2">
                    <h2>urn selection 骨灰瓮选择</h2>
                  </div>
                </b-col>
              </b-row>
              <b-row class="">
                <b-col cols="12">
                  <div class="apf-table-block2 floatCss">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Urn Name</th>
                          <th>Urn Code</th>
                          <th>Unit Price</th>
                          <th>Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ formData.packageName || '-' }}</td>
                          <td>{{ formData.packageCode || '-' }}</td>
                          <td>$ {{ numberFormat(formData.productPrice) }}</td>
                          <td>1</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-section-tittle2">
                    <h2>total purchase price 购买价格</h2>
                    <p>(This Purchase Order serves as a Tax Invoice if GST is charged)</p>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-pl-single-row">
                <b-col
                  cols="6"
                  md="6"
                  lg="6"
                >
                  <div class="ssfp-pl-block floatCss">
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Urn Price 骨灰瓮价格
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        $ {{ numberFormat(formData.productPrice) }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        GST 消费税 {{ formData.gstPercentage || 9 }}%
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        $ {{ numberFormat(formData.gstAmount || 0) }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        <strong>Total 总额</strong>
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        <strong>$ {{ numberFormat(formData.totalAmount || 0) }}</strong>
                      </div>
                    </div>
                  </div>
                </b-col>
                <b-col
                  cols="6"
                  md="6"
                  lg="6"
                >
                  <div class="ssfp-pl-block-right nsf-right floatCss">
                    <h3>NOTES</h3>
                    <p>Full Payment required (Installment Plan is not applicable for the purchase of urn) <br>须缴付总额(购买骨灰瓮不可分期付款)</p>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-section-tittle2">
                    <h2>PARTICULARS of Sales and Service Agent  销售代理及服务代理资料</h2>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-pl-single-row">
                <b-col
                  cols="8"
                  md="8"
                  lg="8"
                >
                  <div class="ssfp-pl-block floatCss">
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Agency 区代理
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        {{ formData.salesAgentAgency }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Sales Agent 销售代理
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        {{ formData.salesAgentName }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Agency 区代理
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        {{ formData.serviceAgentAgency }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Service Agent 服务代理
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        {{ formData.serviceAgentName }}
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-signature ssfp-fsp-gp">
                <b-col cols="12">
                  <div class="pp-signature-area floatCss">
                    <p>Purchaser 购买者签名</p>
                  </div>
                </b-col>
                <b-col cols="12">
                  <b-row>
                    <b-col
                      cols="6"
                      md="6"
                      lg="6"
                    >
                      <div
                        v-if="formData.signOne"
                        class="pp-signature-block floatCss"
                      >
                        <img
                          :src="formData.signOne"
                          alt="signature"
                        >
                      </div>
                      <div
                        v-else
                        id="signOne"
                        class="pp-signature-block signature-block-yellow floatCss"
                      >
                        <span>Sign here</span>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12">
                  <div class="pp-signature-area floatCss">
                    <h4>Name 姓名: {{ formData.customerName }}</h4>
                    <h4>Date 日期: {{ (formData.signOneDate ? dateFormatWithTime(formData.signOneDate) : '') }}</h4>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <!-- eslint-disable-next-line vue/html-self-closing -->
        <div class="page-break-after"></div>
        <div class="formWrapper  niche-wr filled">
          <b-row>
            <b-col cols="12">
              <div class="form-header floatCss">
                <b-row>
                  <b-col cols="12">
                    <div class="form-header-inner d-flex justify-content-between">
                      <div class="d-flex">
                        <div class="dForm-top-logo">
                          <img :src="logoSrc">
                        </div>
                        <div class="dForm-companyDetails">
                          <div class="dForm-cmBlock">
                            <h2>
                              <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                            </h2>
                          </div>
                          <div class="dForm-cmBlock2">
                            <p>(Co. Reg. No. 200401183W)</p>
                            <p>(GST Group Reg. No. M90364395L)</p>
                          </div>
                        </div>
                      </div>
                      <div class="dForm-top-right d-flex">
                        <h5 class="text-block font-small-12">
                          REV: 6
                        </h5>
                        <h5>File No: {{ formData.fileNo || '-' }}</h5>
                        <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle">
                      <h2>sales order - urn 骨灰瓮认购同意书</h2>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-top-20"
            >
              <div class="pp-section-tittle2">
                <h2>TERMS & CONDITIONS</h2>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-top-20"
            >
              <div class="tc-single-wrapper floatCss">
                <div class="pp-section-tittle2 floatCss">
                  <h4>TERM</h4>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    1
                  </div>
                  <div class="tc-info-rt">
                    <p>Mount Prajna Ltd. (hereinafter referred to as "the Vendor") has accepted this Sales Order. In consideration of the sum specified herein paid by Purchaser (the receipt whereof the Vendor hereby acknowledge), the Vendor agrees to sell and provide to the Purchaser the cinerary urn described in the Sales Order.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    2
                  </div>
                  <div class="tc-info-rt">
                    <p>If the Vendor is unable to deliver and provide the cinerary urn as a result of circumstances beyond its control, the Vendor will substitute an alternative cinerary urn of equivalent value.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    3
                  </div>
                  <div class="tc-info-rt">
                    <p>The intended user of the purchased cinerary urn(s) shall be as according to the related purchased niche.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    4
                  </div>
                  <div class="tc-info-rt">
                    <p>If the Vendor is unable to deliver and provide the cinerary urn as a result of circumstances beyond its control, the Vendor will substitute an alternative cinerary urn of equivalent value.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    5
                  </div>
                  <div class="tc-info-rt">
                    <p>Until the urn is delivered to the Purchaser or his intended user no risks in the urn shall be deemed passed to the Purchaser.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    6
                  </div>
                  <div class="tc-info-rt">
                    <div>
                      <p>Purchaser can choose to allow the company to install the selected urn into the related niche compartment at its discretion, or at an arranged date within 3 months upon sales confirmation of urn and the related niche purchase. </p>
                      <br>
                      <p>If the latter, should the purchaser fail to arrange a date within 3 months of the sales submission, the Company reserves the right to install the urn into the purchaser niche’s accordingly.</p>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-10 urn-sales_gap"
            >
              <div class="urn_select floatCss">
                <div
                  class="pp-ssfp-check-info floatCss"
                  :class="{ active: (formData.urnInstallationOption || 'immediate') === 'immediate' }"
                >
                  I authorised the Company to install on my behalf immediately.
                </div>
              </div>
              <div class="urn_select floatCss">
                <div
                  class="pp-ssfp-check-info floatCss"
                  :class="{ active: (formData.urnInstallationOption || 'immediate') !== 'immediate' }"
                >
                  I will arrange a installation date within the stipulated period of 3 months.
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-signature urn-gap-50">
            <b-col cols="12">
              <div class="pp-signature-area floatCss">
                <p>Purchaser 购买者签名</p>
              </div>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col
                  cols="6"
                  md="6"
                  lg="6"
                >
                  <div
                    v-if="formData.signTwo"
                    class="pp-signature-block floatCss"
                  >
                    <img
                      :src="formData.signTwo"
                      alt="signature"
                    >
                  </div>
                  <div
                    v-else
                    id="signTwo"
                    class="pp-signature-block signature-block-yellow floatCss"
                  >
                    <span>Sign here</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <div class="pp-signature-area floatCss">
                <h4>Name 姓名: {{ formData.customerName }}</h4>
                <h4>Date 日期: {{ (formData.signTwoDate ? dateFormatWithTime(formData.signTwoDate) : '') }}</h4>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'

import moment from 'moment'

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoSrc: require('@/assets/images/logo/nr-logo.png'),
      formData: {},
      loading: true,
      loadError: null,
    }
  },

  created() {
    this.loadFormData()
  },

  methods: {
    // App opens this page in a webview with the saved form's id (route param) - fetches the
    // data the app earlier saved via POST /sales/form/urn/data instead of reading injected
    // localStorage, which is what the Puppeteer-rendered source form still does.
    //
    // This hits the front-end/ router (optionalAuth, no token required - the id itself is the
    // access control), not reservation-app/ - so this.$http is safe to use here: no 401 is
    // possible, meaning its global interceptor's hard-redirect-to-/login (src/libs/axios.js)
    // never triggers.
    loadFormData() {
      const { id } = this.$route.params
      this.$http.get(`front-end/sales/form/urn/data/${id}`)
        .then(response => {
          this.formData = response.data.data
          this.loading = false
        })
        .catch(error => {
          this.loadError = (error.response && error.response.data && error.response.data.message) || 'Unable to load form data.'
          this.loading = false
        })
    },
    formatDate(date) {
      if (!date) return '-'
      const timezone = process.env.VUE_APP_TIME_ZONE
      return moment(date).utcOffset(timezone).format('DD/MM/YYYY')
    },
  },
}
</script>

<style>
@media print {
  .page-break-after {
    display: block;
    /* ensure block context */
    page-break-before: always;
    /* legacy */
    break-before: page;
  }

  .formWrapper,
  .niche-wr,
  .ssfp-form-wrapper,
  .ssfp-signature {
    page-break-inside: avoid;
    /* legacy */
    break-inside: avoid;
    /* modern */
  }
}
</style>
